import { jpeg, png } from 'bz-utilities/files/types';

export enum ESizeUnit {
  KB = 1024,
  MB = 1024 * KB,
  GB = 1024 * MB,
  TB = 1024 * GB
}

export const extensions = Object.freeze(['png', 'jpg', 'jpeg'] as const);
export type TExtension = (typeof extensions)[number];

export const mimes = Object.freeze([png, jpeg] as const);
export type TMime = (typeof mimes)[number];

export const blobValidateExtensions = (blob: Blob, allowed: TExtension[]): boolean => {
  const allowedExtensions = new RegExp(`\.(${allowed.join('|')})$`);
  return allowedExtensions.test(blob.name);
};

export const blobValidateMIME = (blob: Blob, allowed: readonly TMime[]): boolean => {
  return allowed.includes(blob.type as TMime);
};

export const blobValidateSize = (blob: Blob, size: number, unit: ESizeUnit): boolean => {
  return blob.size < size * unit;
};
